<template>
  <header class="sticky-top">
    <div>
      <nav class="navbar bg-white border-bottom">
        <div class="container">
          <a class="navbar-brand" href="/">
            <svg id="header-logo" role="img">
              <title>{{ __("lang.kwl.nav_profile.company_name") }}</title>
              <use
                xlink:href="/assets/img/icon-sprite.svg#global.logo"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              ></use>
            </svg>
          </a>
          <nav class="usermenu ml-auto">
            <a class="small text-primary hover-primary mr-3" data-content="newaccountmessage" data-target="#newaccountinfoModal"
               data-toggle="modal" role="button">
              <svg class="icon icon-xs mr-1">
                <use xlink:href="/assets/img/icon-sprite.svg#global.info"
                     xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>
              {{ __('lang.my_account.info.newaccount.goto_old') }}
            </a>
            <a
              aria-expanded="false"
              class="myhelios"
              data-display="static"
              data-reference="parent"
              data-target="#dropdown-login"
              data-toggle="dropdown"
              role="button"
            >
              <span v-if="user.auth && $root.ready" class="d-none d-md-inline"
              >{{ user.first_name }} {{ user.last_name }}</span
              >
              <span v-else class="d-none d-md-inline">{{
                  __('lang.kwl.nav_profile.my_helios')
                }}</span>
              <svg class="icon icon-rg ml-2">
                <use
                  xlink:href="/assets/img/icon-sprite.svg#global.nav.account"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                ></use>
              </svg>
            </a>
            <a
              id="dropdown-language-button"
              aria-expanded="false"
              class="language ml-3"
              data-bs-auto-close="outside"
              data-target="#dropdown-language"
              data-toggle="dropdown"
              role="button"
            >
              <svg class="icon icon-rg">
                <use
                  :xlink:href="
                    '/assets/img/icon-sprite.svg#country.' +
                    userCountry.country_code
                  "
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                ></use>
              </svg>
              <span class="badge badge-primary">{{
                  userCountry.language_code.toUpperCase()
                }}</span>
            </a>
          </nav>
        </div>
      </nav>
    </div>
    <div
      id="dropdown-login"
      class="dropdown-menu border-0 rounded-0 w-100 p-2 bg-gradient-gray shadow"
    >
      <div class="container">
        <div class="row">
          <div class="col-12 text-right">
            <button
              id="header-close-btn"
              aria-label="Close"
              class="close my-2 d-none d-sm-block"
              type="button"
            >
              <svg class="icon">
                <use
                  xlink:href="/assets/img/icon-sprite.svg#global.close"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                ></use>
              </svg>
            </button>
          </div>
        </div>
        <!-- Logged in Profile Nav -->
        <div
          v-if="user.auth && $root.ready"
          class="row mt-md-n3 mb-1 align-items-center"
        >
          <div class="col-12 col-md-4">
            <p class="h4 font-weight-light">
              {{ __('lang.kwl.nav_profile.status') }}
            </p>
            <p class="small mb-1">
              {{ __('lang.kwl.nav_profile.registrated_as') }}
            </p>
            <p class="h4 text-primary font-weight-black mb-0">
              {{ user.first_name }} {{ user.last_name }}
            </p>
            <p
              v-if="user.business_customer == 1"
              class="h6 font-weight-light mb-3"
            >
              {{ __('lang.kwl.nav_profile.businescustomer') }}
            </p>
            <p v-else class="h6 font-weight-light mb-3">
              {{ __('lang.kwl.nav_profile.privatecustomer') }}
            </p>
            <p>
              <a class="btn btn-sm btn-primary border-0" @click="logout">{{
                  __('lang.kwl.nav_profile.logout')
                }}</a>
            </p>
            <hr class="d-block d-md-none"/>
          </div>
          <div class="col-12 col-md-8">
            <ul class="nav nav-inline nav-fill">
              <li v-if="user.registration_complete" class="nav-item col-4">
                <a
                  class="nav-link"
                  role="button"
                  xdata-content="/projekte/"
                  xdata-target="#accountModal"
                  xdata-toggle="modal"
                  @click="setIframeUrl('projects')"
                >
                  <svg class="icon icon-xl mx-auto d-block">
                    <use
                      xlink:href="/assets/img/icon-sprite.svg#account.nav.projects"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    ></use>
                  </svg>
                  <span class="d-none d-md-inline">{{
                      __('lang.kwl.nav_profile.my')
                    }}</span>
                  {{ __('lang.kwl.nav_profile.projects') }}
                </a>
              </li>
              <li v-if="user.registration_complete" class="nav-item col-4">
                <a
                  class="nav-link"
                  role="button"
                  xdata-content="/auslegungen/"
                  xdata-target="#accountModal"
                  xdata-toggle="modal"
                  @click="setIframeUrl('configurations')"
                >
                  <svg class="icon icon-xl mx-auto d-block">
                    <use
                      xlink:href="/assets/img/icon-sprite.svg#account.nav.specifications"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    ></use>
                  </svg>
                  <span class="d-none d-md-inline">{{
                      __('lang.kwl.nav_profile.my')
                    }}</span>
                  {{ __('lang.kwl.nav_profile.configurations') }}
                </a>
              </li>
              <li v-if="user.registration_complete" class="nav-item col-4">
                <a
                  class="nav-link"
                  role="button"
                  xdata-content="/artikel/"
                  xdata-target="#accountModal"
                  xdata-toggle="modal"
                  @click="setIframeUrl('articles')"
                >
                  <svg class="icon icon-xl mx-auto d-block">
                    <use
                      xlink:href="/assets/img/icon-sprite.svg#account.nav.products"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    ></use>
                  </svg>
                  <span class="d-none d-md-inline">{{
                      __('lang.kwl.nav_profile.my')
                    }}</span>
                  {{ __('lang.kwl.nav_profile.articles') }}
                </a>
              </li>
              <li v-if="user.registration_complete" class="nav-item col-4">
                <a
                  class="nav-link"
                  role="button"
                  xdata-content="/kontakte/"
                  xdata-target="#accountModal"
                  xdata-toggle="modal"
                  @click="setIframeUrl('contacts')"
                >
                  <svg class="icon icon-xl mx-auto d-block">
                    <use
                      xlink:href="/assets/img/icon-sprite.svg#account.nav.contacts"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    ></use>
                  </svg>
                  <span class="d-none d-md-inline">{{
                      __('lang.kwl.nav_profile.my')
                    }}</span>
                  {{ __('lang.kwl.nav_profile.contacts') }}
                </a>
              </li>
              <li class="nav-item col-4">
                <a
                  class="nav-link"
                  role="button"
                  xdata-content="/profil/"
                  xdata-target="#accountModal"
                  xdata-toggle="modal"
                  @click="setIframeUrl('profile')"
                >
                  <svg class="icon icon-xl mx-auto d-block">
                    <use
                      xlink:href="/assets/img/icon-sprite.svg#account.nav.profile"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    ></use>
                  </svg>
                  {{ __('lang.my_account.my_profile') }}
                </a>
              </li>
              <li v-if="user.registration_complete" class="nav-item col-4">
                <a
                  class="nav-link"
                  role="button"
                  xdata-content="/einstellungen/"
                  xdata-target="#accountModal"
                  xdata-toggle="modal"
                  @click="setIframeUrl('options')"
                >
                  <svg class="icon icon-xl mx-auto d-block">
                    <use
                      xlink:href="/assets/img/icon-sprite.svg#account.nav.settings"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    ></use>
                  </svg>
                  {{ __('lang.kwl.nav_profile.options') }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!-- /Logged in Profile Nav -->
        <!-- Guest Profile Nav -->
        <div v-else class="row mt-md-n3 mb-1 align-items-center">
          <div class="col-12 col-md-4">
            <p class="h4 font-weight-light">
              {{ __('lang.kwl.nav_profile.status') }}:
            </p>
            <p class="h6 font-weight-light mb-3">
              {{ __('lang.kwl.nav_profile.guest') }}
            </p>
            <div class="text-primary my-3">
              <svg class="icon icon-lg">
                <use
                  xlink:href="/assets/img/icon-sprite.svg#global.warning"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                ></use>
              </svg>
            </div>
            <p class="small">
              {{ __('lang.kwl.nav_profile.login_to_save') }}
              <a
                :href="session.registrationLink"
                class="text-primary hover-primary"
              >{{ __('lang.kwl.nav_profile.register') }}</a
              >.
            </p>
            <hr class="d-block d-md-none"/>
            <p class="text-primary font-weight-bold small">{{ __('lang.my_account.info.newaccount.required.text') }}
              <br/>
              <a class="text-primary hover-primary" data-content="newaccountmessage" data-target="#newaccountinfoModal" data-toggle="modal"
                 role="button">
                <svg class="icon icon-xs mr-1">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.arrow"
                       xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg>
                {{ __('lang.my_account.info.newaccount.required.href') }}
              </a>
            </p>
          </div>
          <div class="col-12 col-md-4">
            <div id="login-view">
              <b-form @submit.stop.prevent>
                <p class="h4 font-weight-light">
                  {{ __('lang.kwl.nav_profile.log_in') }}:
                </p>
                <div class="form-row">
                  <div class="form-group col-12 col-md-9">
                    <input
                      v-model="input.email"
                      autocomplete="username"
                      class="form-control border"
                      name="reg_name"
                      placeholder="E-Mail"
                      type="email"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-12 col-md-9">
                    <input
                      v-model="input.password"
                      autocomplete="current-password"
                      class="form-control border"
                      name="reg_passwd"
                      placeholder="Passwort"
                      type="password"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-6 col-md-3">
                    <button id="login-form-btn"
                            class="btn btn-primary border-0 text-uppercase"
                            @click="submit(input)"
                    >
                      {{ __('lang.kwl.nav_profile.login') }}
                    </button>
                  </div>
                  <div class="form-group col-6 col-md-6 text-right">
                    <a
                      :href="session.passwordLink"
                      class="btn btn-gray-20 btn-sm small pwdreset-btn"
                      role="button"
                    >{{ __('lang.kwl.nav_profile.forgot_password') }}</a
                    >
                  </div>
                </div>
                <hr class="d-block d-md-none"/>
              </b-form>
            </div>
            <div id="pwdreset-view" class="d-none">
              <p class="display-4 font-weight-light">
                {{ __('lang.kwl.nav_profile.forgot_password_question') }}
              </p>
              <p class="small">
                {{ __('lang.kwl.nav_profile.forgot_password_info') }}
              </p>
              <form action="/login/" method="post">
                <div class="form-row">
                  <div class="form-group col-12 col-md-9">
                    <input
                      autocomplete="username"
                      class="form-control border"
                      name="reg_name"
                      placeholder="E-Mail"
                      type="email"
                      value=""
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-6 col-md-3">
                    <button class="btn btn-primary border-0 text-uppercase">
                      {{ __('lang.kwl.nav_profile.send') }}
                    </button>
                  </div>
                  <div class="form-group col-6 col-md-6 text-right">
                    <a
                      class="btn btn-gray-20 btn-sm small login-btn"
                      role="button"
                    >{{ __('lang.kwl.nav_profile.back') }}</a
                    >
                  </div>
                </div>
              </form>
              <hr class="d-block d-md-none"/>
            </div>
          </div>
          <hr class="d-block d-sm-none"/>
          <div class="col-12 col-md-4">
            <p class="h4 font-weight-light">
              {{ __('lang.kwl.nav_profile.register_question') }}
            </p>
            <p class="display-5 font-weight-light">
              {{ __('lang.kwl.nav_profile.advantage') }}:
            </p>
            <ul class="list-unstyled square">
              <li>{{ __('lang.kwl.nav_profile.convenient_project') }}</li>
              <li>{{ __('lang.kwl.nav_profile.secure_storage') }}</li>
              <li>{{ __('lang.kwl.nav_profile.smart') }}</li>
            </ul>
            <p class="font-weight-medium text-underlined">
              {{ __('lang.kwl.nav_profile.now') }}
              <a
                :href="session.registrationLink"
                class="font-weight-medium text-primary hover-primary"
              >{{ __('lang.kwl.nav_profile.here') }}</a
              >
              {{ __('lang.kwl.nav_profile.register') }}!
            </p>
          </div>
        </div>
        <!-- /Guest Profile Nav -->
      </div>
    </div>

    <b-modal
      v-if="user.auth && $root.ready"
      id="accountModal"
      ref="iframemodal"
      v-model="zeigen"
      _no-close-on-backdrop
      body-class="modal-body embed-responsive embed-responsive-16by9"
      centered
      content-class="modal-content rounded-0 border-0 shadow-lg"
      dialog-class="modal-dialog modal-dialog-centered modal-xl"
      header-class="modal-header p-0"
      hide-footer
      modal-class="modal fade"
      no-close-on-esc
      scrollable
      static
    >
      <template #modal-header>
        <button
          aria-label="Close"
          class="close bg-white border position-absolute"
          data-dismiss="modal"
          type="button"
          @click.prevent="closeModal()"
        >
          <span aria-hidden="true">
            <svg class="icon icon-xs">
              <use
                xlink:href="/assets/img/icon-sprite.svg#global.close"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              ></use>
            </svg>
          </span>
        </button>
      </template>
      <div>
        <iframe
          id="my_account"
          :src="myAccountUrl"
          class="embed-responsive-item"
          name="my_account"
        ></iframe>
      </div>
    </b-modal>

    <!--
    <div class="modal fade" id="accountModal" tabindex="-1" aria-hidden="true" _v-show="user.auth" ref="iframemodal">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content rounded-0 border-0 shadow-lg">
          <div id="iframe-close-button">
            <button class="close ml-auto mt-2 mb-2 mr-4" type="button" id="closeAccountModal" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                <svg class="icon icon-xs">
                    <use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                  </svg>
              </span>
            </button>
          </div>
          <div class="modal-body p-1">
            <div class="embed-responsive embed-responsive-16by9">
              <iframe name="my_account" id="my_account" class="embed-responsive-item" :src="myAccountUrl" ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
    -->

    <div
      id="dropdown-language"
      ref="dropdownLanguage"
      aria-labelledby="languageDropdown"
      class="dropdown-menu border-0 rounded-0 w-100 p-2 bg-gradient-gray shadow"
    >
      <div class="container">
        <LanguageComponent></LanguageComponent>
      </div>
    </div>
    <div id="newaccountinfoModal" aria-hidden="true" class="modal fade" data-backdrop="false" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered" style="max-width: 800px !important;">
        <div class="modal-content rounded-lg border-0 shadow-lg">
          <div class="modal-header border-0 pb-0 row">

            <!-- Modal Header -->
            <div class="col-12 text-right">
              <button id="closenewqaccountinfo" aria-label="Close" class="close" data-dismiss="modal"
                      type="button"><span aria-hidden="true">
			                <svg class="icon icon-xs">
			                  <use xlink:href="/assets/img/icon-sprite.svg#global.close"
                             xmlns:xlink="http://www.w3.org/1999/xlink">
			                  </use>
			                </svg></span>
              </button>
            </div>
            <div class="col-12 p-4">
              <h2>{{ __('lang.my_account.info.newaccount.modal.title') }} </h2>
            </div>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <div class="col-12">
              <p>{{ __('lang.my_account.info.newaccount.modal.message.p1_1') }}
                <b>{{ __('lang.my_account.info.newaccount.modal.message.p1_2') }}</b>
                {{ __('lang.my_account.info.newaccount.modal.message.p1_3') }}</p>
              <p>{{ __('lang.my_account.info.newaccount.modal.message.p2_1') }}
                <b>{{ __('lang.my_account.info.newaccount.modal.message.p2_2') }}</b>
                {{ __('lang.my_account.info.newaccount.modal.message.p2_3') }}
                <b>{{ __('lang.my_account.info.newaccount.modal.message.p2_4') }}</b>
                {{ __('lang.my_account.info.newaccount.modal.message.p2_5') }}
                <a :href="infolink" class="text-primary hover-primary"
                   target="_blank">{{ __('lang.my_account.info.newaccount.modal.message.p2_6') }}</a>

              </p>
              <p>{{ __('lang.my_account.info.newaccount.modal.message.p3_1') }}
                <b>{{ __('lang.my_account.info.newaccount.modal.message.p3_2') }}</b>
                {{ __('lang.my_account.info.newaccount.modal.message.p3_3') }}
              </p>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer border-0">
            <button class="btn btn-primary" data-dismiss="modal" type="button">{{
                __('lang.actionbutton.title.close')
              }}
            </button>
          </div>
        </div>
        <!-- </div> -->

      </div>
    </div>

  </header>
</template>

<script>
import {
  login,
  logout,
  getRefreshToken,
} from '@services/helpers/sessionHandler'
import LanguageComponent from './LanguageComponent'
import {errorAlert} from '@services/helpers/helpers'

export default {
  components: {
    LanguageComponent,
  },
  data() {
    return {
      zeigen: false,
      input: {
        email: null,
        password: null,
      },
      myAccountUrl: '',
    }
  },
  methods: {
    errorAlert: errorAlert,
    logout: logout,
    openModal(url) {
      this.zeigen = true
      this.myAccountUrl = url
    },
    closeModal() {
      this.myAccountUrl = ''
      this.zeigen = false
    },
    submit() {
      login(this.input)
    },
    async setIframeUrl(navigation) {
      if (!this.user.auth) {
        this.errorAlert(this.__('lang.error.need_registration'))
        return
      }

      //window.enableLoadingAnimation();
      // we dont need this here because, the loading/waiting animation is not useful because we have no feedback, when the my account has been loaded

      setTimeout(async () => {
        try {
          // needs some more validation
          var response = await getRefreshToken()

          if (!response.data.accessToken || response.data.accessToken == '') {
            // here we need to logout the user, because session is no longer valid
            this.$store.dispatch('session/clearTimer')
            this.$store.dispatch('session/resetState')
            window.disableLoadingAnimation()
            this.$store.dispatch('alert/setAlert', {
              type: 'info',
              message:
                'Sie wurden abgemeldet. Bitte melden Sie sich erneut an.',
            })
            return
          }

          let url =
            this.session.myAccountLink +
            '/' +
            document.documentElement.lang +
            '?access_token=' +
            response.data.accessToken +
            '&target=' +
            navigation +
            '&service=' +
            response.data.service
          if (url.startsWith('#')) {
            window.disableLoadingAnimation()
            this.errorAlert('Can not open My account')
            return
          }
          this.openModal(url)
          window.disableLoadingAnimation()
        } catch (error) {
          window.disableLoadingAnimation()
        }
      }, 10)
    },
    resetIframe() {
      this.myAccountUrl = ''
    },
  },
  watch: {
    zeigen: function (val) {
      if (val === false) {
        this.myAccountUrl = ''
      }
    },
  },
  computed: {
    infolink: function () {
      return this.$lang().locale == 'de' ? this.__('lang.my_account.info.newaccount.modal.message.p2_2_href_de') : this.__('lang.my_account.info.newaccount.modal.message.p2_2_href_en')
    },
    session: {
      get() {
        return this.$store.state.session
      },
    },
    userSession: {
      get() {
        return this.$store.state.User.session
      },
      set(value) {
        this.$store.commit('User/updateSession', value)
      },
    },
    user: {
      get() {
        return this.$store.state.session.user
      },
      set(value) {
        this.$store.commit('session/updateUser', value)
      },
    },
    userCountry: {
      get() {
        return this.$store.state.User.country
      },
      set(value) {
        this.$store.commit('User/updateCountry', value)
      },
    },
    projectData: {
      get() {
        return this.$store.state.User.projectData
      },
      set(value) {
        this.$store.commit('User/updateProjectData', value)
      },
    },
  },
  mounted() {
    //$(this.$refs.iframemodal).on("hidden.bs.modal", this.resetIframe)

    var headerElements = document.getElementsByTagName('header');

    // Add a click event listener to each header element
    for (var i = 0; i < headerElements.length; i++) {
      headerElements[i].addEventListener('click', function (event) {
        // Access the element that was clicked
        var clickedElement = event.target;

        // Log the clicked element's id or tag name

        var clickedElementIsBtn = clickedElement.closest('[role="button"]')

        if (clickedElement.id === 'closeAccountModal' || clickedElement.tagName === 'A' || clickedElement.tagName === 'SPAN' || clickedElement.tagName === 'LI' || clickedElement.tagName === 'svg' || clickedElement.tagName === 'use' || clickedElement.tagName === 'BUTTON') {
          // event.stopPropagation();
        } else if (clickedElement.id === 'login-form-btn') {
          // event.stopPropagation();
          document.getElementById('dropdown-login').classList.remove('show')
        } else {
          event.stopPropagation();
        }

      });
    }
  },
}
</script>
